module.exports = __webpack_public_path__ + "static/media/schody41 - schody drewniane nakladane.74820010.jpg";